/**
 * Optimistic "has boards" hint, persisted in localStorage.
 *
 * The friends list re-hydrates from scratch on every mount (Firestore
 * onSnapshot re-subscribe), so any surface gated on "user has ≥1 recipient"
 * reads false for a beat on every cold load / route hop — flashing the
 * wrong state at returning board-users (marketing hero on the homepage,
 * nav links popping in late in the header). This hint remembers the last
 * hydrated answer so those surfaces can default to it during the window,
 * corrected against the live count once hydrated.
 *
 * Extracted from LandingPage (header/IA spec v5 PR 2) so the homepage
 * layout gate and useDesktopNav share one source of truth.
 */

const KEY = 'thea_has_boards';

export function readHasBoardsHint(): boolean {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function writeHasBoardsHint(hasBoards: boolean): void {
  try {
    if (hasBoards) {
      window.localStorage.setItem(KEY, '1');
    } else {
      window.localStorage.removeItem(KEY);
    }
  } catch {
    /* localStorage unavailable (private mode) — hint stays best-effort */
  }
}
